import { appSync, socketConnected, startListening } from '@betty/toolkit/state';

import { LoyaltyPointsUpdatedEventData } from '../Levels.types';
import {
  fetchLoyaltyLevel,
  loyaltyPointsUpdated,
} from './levels.slice';

startListening({
  actionCreator: appSync,
  effect: (_, { dispatch }) => {
    dispatch(fetchLoyaltyLevel());
  },
});

startListening({
  actionCreator: socketConnected,
  effect: (action, { dispatch }) => {
    const socketConnection = action.payload;

    socketConnection.on(
      'LoyaltyPointsUpdated',
      (data: LoyaltyPointsUpdatedEventData) => {
        if (!data) {
          return;
        }

        dispatch(loyaltyPointsUpdated(data));
      },
    );
  },
});
